import { useEffect } from 'react';
import { IS_QUALITYLODGINGS } from '../../constants/analyticsEvents';

const useAnalyticsContentCategory = (contentCategory?: string) => {
    useEffect(() => {
        if (IS_QUALITYLODGINGS || !contentCategory) {
            return;
        }
        setTimeout(() => {
            window.dataLayer = window.dataLayer ?? [];
            window.dataLayer.push({
                content_category: contentCategory,
            });
        });
    }, [contentCategory]);
};

export default useAnalyticsContentCategory;
